import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { SendBackToCanadaDto, SendBackToCanadaQueryParams } from 'dtos/toDoLists/conformity'
import { URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/conformity/send-back-to-canada`

export const getToDoList = (queryParams: SendBackToCanadaQueryParams, cancelToken?: CancelToken) =>
  apiClient.get<ApiResponse<SendBackToCanadaDto[]>>(baseUrl() + URIQuery(queryParams), { cancelToken }).then(res => res.data)
